import FormatMessage from "@irati/utils/lang"
import Validation, {StringSchema} from "@irati/utils/validation"

const mobileSchema: (formatMessage: FormatMessage) => StringSchema = (formatMessage) => {
  /* eslint-disable no-useless-escape */
  return Validation.string("platform.defaultValidation.required")
    .transform((value) => (!value ? null : value))
    .min(7, formatMessage({id: "platform.fields.phone.validation.matches"}))
    .max(15, formatMessage({id: "platform.fields.phone.validation.max"}))
    .matches(
      /^[+]?([\d]{0,3})?[\(\.\-\s]?(([\d]{1,3})[\)\.\-\s]*)?(([\d]{3,5})[\.\-\s]?([\d]{4})|([\d]{2}[\.\-\s]?){4})$/,
      formatMessage({id: "platform.fields.phone.validation.matches"})
    )
  /* eslint-enable no-useless-escape */
}

export default mobileSchema
